import users from './users';
import { getExamsMenuItems } from './exams';

// 동적 메뉴 생성 함수
export const getTeacherMenuItems = (aiEvaluationEnabled = false) => {
  return {
    items: [users, getExamsMenuItems(aiEvaluationEnabled)]
  };
};

// 기본 export (하위 호환성)
const menuItems = {
  items: [users, getExamsMenuItems(false)]
};

export default menuItems;
